<template>
<div style="height:100vh" class="d-flex flex-column align-center justify-center ma-4">
      <h1 class="text-center">{{$t("auth.callback.logout")}}</h1>
      <v-img
        contain
        alt="Image de l'ours Genius"
        max-height="500px"
        height="100vh"
        src="/media/svg/illustrations/TMG_ours-fusee-qui-vole.gif"
      >
      </v-img>
</div>
</template>
<style>
body {
  background:white;
}
  </style>
<script>
import { LOGOUT } from "@/core/services/store/auth.module";
export default {
  name: "logout",
  mounted() {
    setTimeout(() => {
      this.$store.dispatch(LOGOUT)
      .then((redirect_url) => redirect_url != null ? window.location.href = redirect_url : this.$router.push({ name: "login" }))
      .catch(() => this.$router.push({ name: "login" }) );
    }, 500);
  },
};
</script>
